console.log('invest.js');

import * as Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import {createPinia, setMapStoreSuffix} from 'pinia';
import VueSmoothScroll from 'vue3-smooth-scroll';
import DInvest from '@components/organisms/DInvest.vue';

$(window).on('load', function(e) {

    let $advantagesItem = $('.d-investment-advantages-item');
    $advantagesItem.on('click', function() {
        if (window.matchMedia('(pointer: coarse)').matches) {
            if ($(this).hasClass('_active')) {
                $(this).removeClass('_active');
            }
            else {
                $advantagesItem.removeClass('_active').filter(this).addClass('_active');
            }
        }
    });

    $(document).on('click', function(e) {
        if (!$(e.target).closest('.d-investment-advantages-item').length) {
            $advantagesItem.removeClass('_active');
        }
    });

    $(document).on('keyup', function(e) {
        if (e.key === 'Escape') {
            $advantagesItem.removeClass('_active');
        }
    });

    try {
        setMapStoreSuffix('');

        const mountEl = document.querySelector('.d-investment__content');
        const pinia = createPinia();
        const app = Vue.createApp(DInvest, {...mountEl.dataset});
        app.use(VueAxios, axios);
        app.use(pinia);
        app.use(VueSmoothScroll);
        app.mount('.d-investment__content');
    } catch (e) {
        console.error(e);
    }
});
